/* A/W'26 campaign page sliders (jQuery + slick ship in vendor.min.js). */
(function () {
  /* mir/icon/regular/CaretLeft|CaretRight, 24 x 24, inside a 44px transparent button. */
  function caret(direction) {
    var points = direction === 'prev' ? '160 208 80 128 160 48' : '96 48 176 128 96 208';

    return (
      '<button type="button" class="slick-' +
      direction +
      '" aria-label="' +
      (direction === 'prev' ? 'Previous' : 'Next') +
      '">' +
      '<svg width="24" height="24" viewBox="0 0 256 256" fill="none" aria-hidden="true">' +
      '<polyline points="' +
      points +
      '" stroke="currentColor" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg></button>'
    );
  }

  function initRail($root) {
    $root.find('.aw26-rail__list').each(function () {
      var $list = window.jQuery(this);

      /* Four across, so anything past the fourth card needs the arrows to reach it. The threshold was 6,
         which no rail on this page ever hits — rail_1 renders 3, rail_2 5, rail_3 6 — so none of them
         became a carousel and the frame's chevrons never appeared. Matching slidesToShow keeps rail_1
         static (3 fit) and gives rails 2 and 3 the arrows the frame draws. */
      if ($list.hasClass('slick-initialized') || $list.children().length <= 4) {
        return;
      }

      $list.slick({
        /* Same mir/icon/regular/Caret buttons the split slider uses. Without these slick falls back to its
           own <button> whose glyph comes from a ::before this file blanks out, so the arrows render as
           invisible 44px hit areas — present in the DOM, nothing on screen. */
        prevArrow: caret('prev'),
        nextArrow: caret('next'),
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        /* The frames only specify 1440 and 375, so the range between is ours to choose. Holding 4-up all the
           way down put 180px cards at 718 against the frame's 356.5 — half size, with the swatch row running
           out of the card. Stepping down keeps cards roughly 300-420 wide, which is where the frame's 356.5
           sits, and below 700 the mobile grid takes over. */
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 3 },
          },
          {
            breakpoint: 900,
            settings: { slidesToShow: 2 },
          },
          {
            breakpoint: 700,
            settings: 'unslick',
          },
        ],
      });
    });
  }

  function init($root) {
    initRail($root);
  }

  function whenReady(callback) {
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      callback();
      return;
    }

    window.setTimeout(function () {
      whenReady(callback);
    }, 50);
  }

  whenReady(function () {
    init(window.jQuery(document));

    document.addEventListener('shopify:section:load', function (event) {
      init(window.jQuery(event.target));
    });
  });
})();
